
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { apiSlice } from '../apiSlice';

export const selectRefDataRaw = (state: RootState) => apiSlice.endpoints.getRefDataList.select()(state);

export const selectRefDataLoaded = createSelector(
  [selectRefDataRaw],
  (slice) => slice.status === 'fulfilled'
);

export const selectRefDataLoading = createSelector(
  [selectRefDataRaw],
  (slice) =>  slice.isLoading
);

export const selectRefDataStatus = createSelector(
  [selectRefDataRaw],
  (slice) =>  slice.status
);


export const selectRefData = createSelector(
  [selectRefDataRaw],
  (refData) => {
    return refData.data ? refData?.data.map(({ id, code, categoryCode, description, domainKey }) =>
      ({  id, code, categoryCode, description, domainKey })
    ) : [];
  }
);